import { OBSERVATION_CODE_SYSTEMS } from './Ecart.ts';

// Default UCUM for vital-sign LOINC codes; excludes the multi-component BP panel (85354-9) and temperature, neither of which has one safe default unit.
export const VITAL_SIGN_LOINC_DEFAULT_UCUM: Readonly<Record<string, string>> = Object.freeze({
  '8867-4': '/min', // Heart rate — ehr-ecart INPUT_UNITS[HEART_RATE]
  '9279-1': '/min', // Respiratory rate — ehr-ecart INPUT_UNITS[RESPIRATORY_RATE]
  '59408-5': '%', // Oxygen saturation, arterial, pulse oximetry — ehr-ecart INPUT_UNITS[OXYGEN_SATURATION]
  '20564-1': '%', // Oxygen saturation in Blood (alt code) — ehr-ecart INPUT_UNITS[OXYGEN_SATURATION]
  '8480-6': 'mm[Hg]', // Systolic blood pressure — ehr-ecart INPUT_UNITS[SYSTOLIC_BLOOD_PRESSURE]
  '8462-4': 'mm[Hg]', // Diastolic blood pressure — ehr-ecart INPUT_UNITS[DIASTOLIC_BLOOD_PRESSURE]
  '3150-0': '%', // Inhaled oxygen concentration (FiO2) — ehr-ecart INPUT_UNITS[FIO2]
  '19993-5': '%', // FiO2, alt LOINC code — ehr-ecart INPUT_UNITS[FIO2]
  '19995-0': '%', // FiO2, alt LOINC code — ehr-ecart INPUT_UNITS[FIO2]
  '19996-8': '%' // Oxygen/Inspired gas Respiratory system --on ventilator (FiO2) — ehr-ecart INPUT_UNITS[FIO2]
});

// Undefined means "not a known vital sign" — callers should leave suggestedUcum untouched rather than guess.
export function getDefaultVitalSignUcum(system: string, code: string): string | undefined {
  if (system !== OBSERVATION_CODE_SYSTEMS.LOINC) {
    return undefined;
  }

  return VITAL_SIGN_LOINC_DEFAULT_UCUM[code];
}
